import _Vue from "vue";
import GdaClient from "@/assets/gda/gda_client_api";
import PubSub from "pubsub-js";

/**
 * This plugin requires the easyXDM library
 */
export default {
  install: (Vue: typeof _Vue, options: any = {}): void => {
    // load config from env variables
    const env__gdaConfig = {} as any;
    if (process.env.VUE_APP_GDA_EXTERNALBASEURL)
      env__gdaConfig.externalBaseUrl = process.env.VUE_APP_GDA_EXTERNALBASEURL;
    if (process.env.VUE_APP_GDA_EXTERNALEAPPLICATIONID)
      env__gdaConfig.externalApplicationId =
        process.env.VUE_APP_GDA_EXTERNALEAPPLICATIONID;
    if (process.env.VUE_APP_GDA_DSPFUSERID)
      env__gdaConfig.dspfUserId = process.env.VUE_APP_GDA_DSPFUSERID;
    if (process.env.VUE_APP_GDA_DATASCOUTBASEURL)
      env__gdaConfig.datascoutBaseURL =
        process.env.VUE_APP_GDA_DATASCOUTBASEURL;
    if (process.env.VUE_APP_GDA_WINOPTS)
      env__gdaConfig.winOpts = process.env.VUE_APP_GDA_WINOPTS;

    env__gdaConfig.recieveCoordinate = (x: any, y: any) => {
      PubSub.publish("recieveCoordinate", [x, y]);
    };

    // merge optiosn config with env config
    const default_gdaConfig = Object.assign(env__gdaConfig, options);
    // initialise GDA
    const gdaClient = new GdaClient(default_gdaConfig);
    gdaClient.init();

    // set gda client as global vue variable
    Vue.prototype.$gdaClient = gdaClient;

    console.log("GDA initialized");
  },
};
